import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Modal as AntdModal,
  InputNumber,
  Row,
  Col,
  Select,
} from "antd";
import { getChannelList } from "@/api/brand";
import { phoneReg } from "@/utils/rules";

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};

const Modal = (props) => {
  const {
    form,
    current,
    visible,
    onAdd = () => {},
    onCancel = () => {},
    getContainer,
    onEdit = () => {},
  } = props; 
  const [data, setData] = useState([]);

  useEffect(() => { 
    getChannelList().then((res) => {
      if (res.success) {
        setData(
          res.data.map((item) => ({
            label: item.companyName,
            value: item.companyId,
          }))
        );
      }
    }); 
  }, []);

  const handleConfirm = () => {
    form.validateFields((err, values) => {
      if (!err) {
        if (current.companyId) {
          onEdit({ ...values, companyId: current.companyId });
        } else {
          onAdd(values);
        }
      }
    });
  }; 
  console.log("==current==>", current);
  return (
    <AntdModal
      destroyOnClose={true}
      title={current?.companyId ? "编辑品牌商" : "添加品牌商"}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onCancel}
      width={710}
      wrapClassName={"modal"}
      getContainer={getContainer}
    >
      <Form {...formItemLayout}>
        <Form.Item label="品牌商名称">
          {form.getFieldDecorator(
            "companyName",
            current.companyName
              ? {
                  initialValue: current.companyName,
                  rules: [{ required: true, message: "请输入品牌商名称" }],
                }
              : {
                  rules: [{ required: true, message: "请输入品牌商名称" }],
                }
          )(
            <Input
              placeholder="请输入品牌商名称"
              style={{ width: 324 }} 
            />
          )}
        </Form.Item>
        <Form.Item label="联系人">
          {form.getFieldDecorator("contacts", {
            initialValue: current.contacts,
            rules: [{ required: true, message: "请输入联系人名称" }],
          })(<Input placeholder="请输入联系人名称" style={{ width: 324 }} />)}
        </Form.Item>
        <Form.Item label="联系方式">
          {form.getFieldDecorator("telephone", {
            initialValue: current.telephone,
            rules: [
              { required: true, message: "请输入联系方式", pattern: phoneReg },
            ],
          })(<Input placeholder="请输入联系方式" style={{ width: 324 }} />)}
        </Form.Item>
        <Form.Item label="登录账号" className="mobilePhone-formItem">
          {form.getFieldDecorator("mobilePhone", {
            initialValue: current.mobilePhone,
            rules: [
              { required: true, message: "请输入登录账号", pattern: phoneReg },
            ],
          })(<Input placeholder="请输入登录账号" style={{ width: 324 }} />)}
        </Form.Item>
        <Row>
          <Col xs={12} sm={6}></Col>
          <Col>
            <span className="tip">初始密码为手机号后六位</span>
          </Col>
        </Row>
        <Form.Item label="渠道商名称">
          {form.getFieldDecorator("channelCompanyId", {
            initialValue: current.channelCompanyId===0?null:current.channelCompanyId,
            rules: [
              {
                required: true,
                message: "请输入渠道商名称",
              },
            ],
          })(
            <Select style={{ width: 324 }} disabled={data.length == 0}>
              {data.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Form>
    </AntdModal>
  );
};

export default Form.create()(Modal);
